// @ts-nocheck
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { PostApi } from "../../../ApiClient/PostApi";
import { error_toaster, success_toaster } from "../../toaster/Toaster";

import { Loader2 } from "../../loader/Loader";
export default function ForgetPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const forget_password = async (event) => {
    event.preventDefault();

    if (email === "") {
      error_toaster("Email is required!");
      return false;
    } else {
      setLoading(true);
      const res = await PostApi("users/forget_password", {
        email: email,
      });
      if (res.data.status === "1") {
        setLoading(false);
        localStorage.setItem("email", res.data.data.email);
        success_toaster(res.data.message);
        navigate("/verify_otp");
      } else {
        setLoading(false);
        success_toaster(res.data.message);
      }
    }
  };
  const body = "body {background: #FFFFFF !important}";
  const inputStyle =
    "bg-themeGray border-none font-normal sm:text-xl text-lg px-5 py-3 rounded-lg placeholder:text-black placeholder:text-opacity-40 focus:outline-none";
  return (
    <>
      <style>{body}</style>
      <section className="grid lg:grid-cols-2 h-[100vh]">
        <div className="bg-themeBlue lg:py-12 py-4 lg:px-12 px-2 flex lg:flex-col items-center justify-center lg:gap-y-12">
          <div className="lg:block hidden">
            <img
              src="images/dashboard/car_loader.webp"
              alt="cart"
              className="xl:w-[440px] lg:w-80"
            />
          </div>
          <Link to={"/"} className="p-0">
            <img src="images/logo.webp" alt="logo" className="xl:w-60 w-52" />
          </Link>
          <p className="font-normal xl:text-2xl lg:text-xl text-white text-center xl:w-4/5 mx-auto lg:block hidden">
            Lorem ipsum dolor sit amet consectetur. Vitae cras tortor nisl felis
            ultricies odio elementum ut. Sagittis mattis mauris commodo cras.
            Amet pellentesque morbi mauris blandit. Eu in at lectus dolor libero
            at integer tempus proin.
          </p>
        </div>
        {loading ? (
          <Loader2 />
        ) : (
          <div className="xl:w-1/2 lg:w-3/4 md:w-1/2 sm:w-2/3 w-4/5 mx-auto flex flex-col justify-center gap-y-8">
            <h1 className="font-bold sm:text-5xl text-4xl">Forget Password</h1>
            <div className="flex flex-col gap-y-4">
              <input
                type="email"
                name="email"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                placeholder="Enter your email address"
                className={inputStyle}
              />
            </div>

            <button
              onClick={forget_password}
              className="bg-themeBlue text-white font-medium sm:text-xl text-lg py-3 px-8 rounded-md w-full border border-themeBlue hover:bg-transparent hover:text-themeBlue"
            >
              Submit
            </button>

            <Link
              to={"/signup"}
              className="text-themeBlue font-medium sm:text-xl text-lg text-center py-3 px-8 rounded-md w-full border border-themeBlue hover:bg-themeBlue hover:text-white"
            >
              Create new account
            </Link>
          </div>
        )}
      </section>
    </>
  );
}
